import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { issuesSnoozedGetSlice } from './get';

export const issuesSnoozedReducers = combineReducers({
	get: issuesSnoozedGetSlice.asyncReducers
});

export const issuesSnoozedWatchers = combineAllWatchers([ issuesSnoozedGetSlice.asyncWatchers ]);
